export function normalizeExtensions(extensions) {
    const set = new Set();
    for (const ext of extensions ?? []) {
        const token = ext.trim().toLowerCase();
        if (token)
            set.add(token);
    }
    return set;
}
export function supportsExtension(capabilities, name) {
    if (!capabilities)
        return false;
    return normalizeExtensions(capabilities.extensions).has(name.toLowerCase());
}
/** Core constructs that do not need a require (RFC 5228). */
export const CORE_ALWAYS = new Set([
    "if",
    "elsif",
    "else",
    "allof",
    "anyof",
    "not",
    "header",
    "address",
    "size",
    "exists",
    "true",
    "false",
    "keep",
    "discard",
    "redirect",
    "stop",
    "require",
]);
export function isPaletteItemAvailable(capabilities, item) {
    if (!item.requires || item.requires.length === 0) {
        return true;
    }
    if (!capabilities) {
        return false;
    }
    const available = normalizeExtensions(capabilities.extensions);
    return item.requires.every((req) => available.has(req.toLowerCase()));
}
